import { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import "./PdfExtratoCliente.scss";
import moment from "moment";

function PdfExtratoCliente({ showPreviousPage, dados }) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Extrato_${dados.cliente.nome}_${moment(
      dados.periodo.dataInicial,
    ).format("DD-MM-YYYY")}_${moment(dados.periodo.dataFinal).format(
      "DD-MM-YYYY",
    )}`,
    onAfterPrint: () => {
      showPreviousPage();
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  const formatarData = (data) => {
    return moment(data).format("DD/MM/YYYY");
  };

  const formatarValor = (valor) => {
    return valor ? valor.toLocaleString("pt-BR") + "$00" : "0$00";
  };

  return (
    <>
      <div
        ref={componentRef}
        className={`pdf-wrapper ${dados.clinica?.configuracoes?.configuracoes?.impressaoPretoEBranco?.ativo ? " pdf-wrapper--pretoebranco" : ""}`}
      >
        {/* CABEÇALHO */}
        <div className="pdf-extrato-heading">
          <div className="pdf-extrato-heading__clinica">
            <span className="nome-clinica">{dados.clinica.nome}</span>
            <span className="nif-clinica">NIF: {dados.clinica.nif}</span>
          </div>
          <div className="pdf-extrato-heading__titulo">
            <span>Extrato do Cliente</span>
            <span className="periodo">
              {formatarData(dados.periodo.dataInicial)} a{" "}
              {formatarData(dados.periodo.dataFinal)}
            </span>
          </div>
        </div>

        {/* DADOS DO CLIENTE */}
        <div className="pdf-extrato-cliente">
          <span className="cliente-nome">{dados.cliente.nome}</span>
          <span className="cliente-detalhe">
            NIF: {dados.cliente.nif || "-"} | Contacto:{" "}
            {dados.cliente.contacto || "-"}
          </span>
        </div>

        {/* RESUMO FINANCEIRO */}
        <div className="pdf-extrato-resumo">
          <div className="resumo-row">
            <span className="label">Total Geral:</span>
            <span className="valor">
              {formatarValor(dados.resumo.totalGeral)}
            </span>
          </div>
          <div className="resumo-row">
            <span className="label">Total Pago:</span>
            <span className="valor valor-pago">
              {formatarValor(dados.resumo.totalPago)}
            </span>
          </div>
          <div className="resumo-row">
            <span className="label">Descontos Aplicados:</span>
            <span className="valor valor-desconto">
              {formatarValor(dados.resumo.descontosAplicados)}
            </span>
          </div>
          <div className="resumo-row destaque">
            <span className="label">Saldo em Aberto:</span>
            <span className="valor valor-aberto">
              {formatarValor(dados.resumo.saldoAberto)}
            </span>
          </div>
        </div>

        {/* TABELA DE MOVIMENTOS */}
        <div className="pdf-extrato-table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Descrição</th>
                <th>DFE</th>
                <th>Método</th>
                <th>Valor</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {dados.movimentos.map((movimento, index) => (
                <tr key={index} className={movimento.pago ? "" : "pendente"}>
                  <td>
                    {movimento.pago
                      ? formatarData(movimento.dataPagamento)
                      : formatarData(movimento.dataLimitePagamento)}
                  </td>
                  <td>
                    {movimento.pago === false && movimento.tipo === "parcela"
                      ? "Parcela "
                      : ""}
                    {movimento.descricao || "-"}
                    {movimento.nrParcela && ` (${movimento.nrParcela})`}
                  </td>
                  <td>
                    {movimento.documentoEletronico
                      ? `${movimento.documentoEletronico.tipoDocumento} ${movimento.documentoEletronico.nrDocumento}`
                      : "-"}
                  </td>
                  <td>{movimento.metodoPagamento || "-"}</td>
                  <td className="valor-cell">
                    {formatarValor(
                      movimento.pago
                        ? movimento.valor
                        : movimento.valorPorPagar || movimento.valor,
                    )}
                  </td>
                  <td>
                    <span
                      className={`estado-badge ${
                        movimento.pago ? "pago" : "pendente"
                      }`}
                    >
                      {movimento.pago ? "Pago" : "Pendente"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* RODAPÉ - TOTAIS POR MÉTODO */}
        <div className="pdf-extrato-rodape">
          <div className="pdf-extrato-rodape__metodos">
            <h4>Totais por Método de Pagamento</h4>
            {Object.entries(dados.totaisPorMetodo).map(([metodo, valor]) => (
              <div className="metodo-row" key={metodo}>
                <span className="metodo-nome">{metodo}:</span>
                <span className="metodo-valor">{formatarValor(valor)}</span>
              </div>
            ))}
          </div>

          <div className="pdf-extrato-rodape__saldo-final">
            <span className="label">Saldo em Aberto:</span>
            <span className="valor">
              {formatarValor(dados.resumo.saldoAberto)}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default PdfExtratoCliente;
